import {
  diffMinutesAppDateTime,
  nowIst,
  parseAppDateTime,
} from "../common/dateTimeIst";

export const isSessionPaused = (session) =>
  Boolean(session) && (session.isPaused === true || Number(session.isPaused) === 1);

/** Live working minutes excluding accumulated and current pause time. */
export const computeLiveWorkingMinutes = (session) => {
  if (!session?.checkInAt) return null;
  if (session.liveWorkingMinutes != null && Number(session.liveWorkingMinutes) > 0) {
    return Math.round(Number(session.liveWorkingMinutes));
  }

  const now = nowIst();
  let minutes = diffMinutesAppDateTime(session.checkInAt, now);
  let paused = Math.round(Number(session.totalPausedMinutes) || 0);

  if (isSessionPaused(session) && session.pausedAt) {
    paused += diffMinutesAppDateTime(session.pausedAt, now);
  }

  return Math.max(0, minutes - paused);
};

export { parseAppDateTime };
